// HOW TO USE:
/* <div class="lite-youtube">
videoid="YFqwdMS4dIM", videoStartAt="4", params="cc_lang_pref=es;cc_load_policy=1",
cover="https://www.japanesegreenteain.com/cdn/shop/files/JapaneseGreenTeaCo-Matcha-optimazed.png?v=1723920415"
</div>  */

function parseLiteYoutubeTextConfig(text) {
  const matches = text.matchAll(/([a-zA-Z][\w-]*)\s*=\s*"([^"]*)"/g);
  const attributes = {};

  for (const [, key, value] of matches) {
    attributes[key] = value;
  }

  return attributes;
}

function hydrateLiteYoutubeConfig(element) {
  const textConfig = element.textContent?.trim();

  if (!textConfig || !textConfig.includes("=")) {
    return;
  }

  const attributes = parseLiteYoutubeTextConfig(textConfig);

  if (!Object.keys(attributes).length) {
    return;
  }

  Object.entries(attributes).forEach(([key, value]) => {
    if (!element.hasAttribute(key)) {
      element.setAttribute(key, value);
    }
  });

  if (element.classList.contains("lite-youtube-dev")) {
    element.classList.remove("lite-youtube-dev");
    element.classList.add("lite-youtube");
  }

  element.textContent = "";
}

class LiteYTEmbedDiv {
  constructor(self) {
    if (self.liteYoutubeInstance) return self.liteYoutubeInstance;

    this.self = self;
    this.isIframeLoaded = false;
    this.self.liteYoutubeInstance = this;
    hydrateLiteYoutubeConfig(this.self);
    this.setupDom();
    this.setupComponent();
    this.self.addEventListener(
      "pointerover",
      () => LiteYTEmbedDiv.warmConnections(this.noCookie),
      { once: true },
    );
    this.self.addEventListener("click", () => this.addIframe());
  }

  get videoId() {
    return encodeURIComponent(
      this.self.getAttribute("videoid") ||
        this.self.getAttribute("data-sanitized-videoid") ||
        "",
    );
  }
  set videoId(id) {
    this.self.setAttribute("videoid", id);
  }
  get cover() {
    return encodeURIComponent(
      this.self.getAttribute("cover") ||
        this.self.getAttribute("data-sanitized-cover") ||
        "",
    );
  }
  get playlistId() {
    return encodeURIComponent(this.self.getAttribute("playlistid") || "");
  }
  set playlistId(id) {
    this.self.setAttribute("playlistid", id);
  }
  get videoTitle() {
    return this.self.getAttribute("videotitle") || "Video";
  }
  set videoTitle(title) {
    this.self.setAttribute("videotitle", title);
  }
  get videoPlay() {
    return this.self.getAttribute("videoPlay") || "Play";
  }
  set videoPlay(name) {
    this.self.setAttribute("videoPlay", name);
  }
  get videoStartAt() {
    return this.self.getAttribute("videoStartAt") || "0";
  }
  get autoLoad() {
    return this.self.hasAttribute("autoload");
  }
  get noCookie() {
    return this.self.hasAttribute("nocookie");
  }
  get posterQuality() {
    return this.self.getAttribute("posterquality") || "maxresdefault";
  }
  get posterLoading() {
    return this.self.getAttribute("posterloading") || "lazy";
  }
  get params() {
    return `start=${this.videoStartAt}&${this.self.getAttribute("params")}`;
  }
  set params(opts) {
    this.self.setAttribute("params", opts);
  }

  setupDom() {
    if (this.self.shadowRoot) return;

    const shadowDom = this.self.attachShadow({ mode: "open" });
    shadowDom.innerHTML = `
        <style>
          :host {
            contain: content;
            display: block;
            position: relative;
            width: 100%;
            padding-bottom: calc(100% / (16 / 9)) !important;
            margin-bottom: 1rem;
            --lyt-animation: all 0.2s cubic-bezier(0, 0, 0.2, 1);
            --lyt-play-btn-default: #212121;
            --lyt-play-btn-hover: #f00;
          }

          @media (max-width: 40em) {
            :host([short]) {
              padding-bottom: calc(100% / (9 / 16));
            }
          }

          #frame, #fallbackPlaceholder, iframe {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
          }

          #frame {
            cursor: pointer;
          }

          #fallbackPlaceholder {
            object-fit: cover;
          }

          #frame::before {
            content: '';
            display: block;
            position: absolute;
            top: 0;
            background-image: linear-gradient(180deg, #111 -20%, transparent 90%);
            height: 60px;
            width: 100%;
            transition: var(--lyt-animation);
            z-index: 1;
          }

          #playButton {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1;
            //display: none;
            padding: 0;
            width: 68px;
            height: 48px;
            border: none;
            background-color: transparent;
            transform: translate(-50%, -50%);
            cursor: pointer;
          }

          #playButton:focus {
            outline: none;
          }

          #playButton .playButton__shape{
            fill: #212121;
            fill-opacity: 0.8;
        transition: all 0.3s ease;
          }

          #playButton .playButton__icon{
            fill: #ffffff;
          }
          #frame:hover > #playButton .playButton__shape,
          #frame:focus > #playButton .playButton__shape{
            fill: #ff0000;
            fill-opacity: 1;
          }


          /* Post-click styles */
          .activated {
            cursor: unset;
          }

          #frame.activated::before,
          #frame.activated > #playButton {
            display: none;
          }
        </style>
        <div id="frame">
          <picture>
            <source id="webpPlaceholder" type="image/webp">
            <source id="jpegPlaceholder" type="image/jpeg">
            <source id="imagePlaceholder">
            <img id="fallbackPlaceholder" referrerpolicy="origin" loading="lazy">
          </picture>
          <button id="playButton">
            <svg width="68" height="48" viewBox="0 0 68 48"><path class="playButton__shape" d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z"></path><path class="playButton__icon" d="M 45,24 27,14 27,34"></path></svg>
          </button>
        </div>
      `;
    this.domRefFrame = shadowDom.querySelector("#frame");
    this.domRefImg = {
      fallback: shadowDom.querySelector("#fallbackPlaceholder"),
      webp: shadowDom.querySelector("#webpPlaceholder"),
      jpeg: shadowDom.querySelector("#jpegPlaceholder"),
      image: shadowDom.querySelector("#imagePlaceholder"),
    };
    this.domRefPlayButton = shadowDom.querySelector("#playButton");
  }

  setupComponent() {
    this.initImagePlaceholder();
    this.domRefPlayButton.setAttribute(
      "aria-label",
      `${this.videoPlay}: ${this.videoTitle}`,
    );
    this.self.setAttribute("title", `${this.videoPlay}: ${this.videoTitle}`);
    if (this.autoLoad || this.isYouTubeShort()) {
      this.initIntersectionObserver();
    }
  }

  addIframe(isIntersectionObserver = false) {
    if (!this.isIframeLoaded) {
      let autoplay = isIntersectionObserver ? 0 : 1;
      const wantsNoCookie = this.noCookie ? "-nocookie" : "";
      let embedTarget;
      if (this.playlistId) {
        embedTarget = `?listType=playlist&list=${this.playlistId}&`;
      } else {
        embedTarget = `${this.videoId}?`;
      }
      if (this.isYouTubeShort()) {
        this.params = `loop=1&mute=1&modestbranding=1&playsinline=1&rel=0&enablejsapi=1&playlist=${this.videoId}`;
        autoplay = 1;
      }
      const iframeHTML = `
<iframe frameborder="0"
allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
src="https://www.youtube${wantsNoCookie}.com/embed/${embedTarget}autoplay=${autoplay}&${this.params}"
></iframe>`;
      this.domRefFrame.insertAdjacentHTML("beforeend", iframeHTML);
      this.domRefFrame.classList.add("activated");
      this.isIframeLoaded = true;
      this.attemptShortAutoPlay();
      this.self.dispatchEvent(
        new CustomEvent("liteYoutubeIframeLoaded", {
          detail: {
            videoId: this.videoId,
          },
          bubbles: true,
          cancelable: true,
        }),
      );
    }
  }
  initImagePlaceholder() {
    if (this.cover) {
      const posterUrlImage = decodeURIComponent(this.cover);
      this.domRefImg.fallback.loading = this.posterLoading;
      this.domRefImg.image.srcset = posterUrlImage;
      this.domRefImg.fallback.src = posterUrlImage;
      this.domRefImg.fallback.setAttribute(
        "aria-label",
        `${this.videoPlay}: ${this.videoTitle}`,
      );
      this.domRefImg?.fallback?.setAttribute(
        "alt",
        `${this.videoPlay}: ${this.videoTitle}`,
      );
      return;
    }

    LiteYTEmbedDiv.addPrefetch("preconnect", "https://i.ytimg.com/");
    const posterUrlWebp = `https://i.ytimg.com/vi_webp/${this.videoId}/${this.posterQuality}.webp`;
    const posterUrlJpeg = `https://i.ytimg.com/vi/${this.videoId}/${this.posterQuality}.jpg`;
    this.domRefImg.fallback.loading = this.posterLoading;
    this.domRefImg.webp.srcset = posterUrlWebp;
    this.domRefImg.jpeg.srcset = posterUrlJpeg;
    this.domRefImg.fallback.src = posterUrlJpeg;
    this.domRefImg.fallback.setAttribute(
      "aria-label",
      `${this.videoPlay}: ${this.videoTitle}`,
    );
    this.domRefImg?.fallback?.setAttribute(
      "alt",
      `${this.videoPlay}: ${this.videoTitle}`,
    );
  }
  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.isIframeLoaded) {
          LiteYTEmbedDiv.warmConnections(this.noCookie);
          this.addIframe(true);
          observer.unobserve(this.self);
        }
      });
    }, options);
    observer.observe(this.self);
  }
  attemptShortAutoPlay() {
    if (this.isYouTubeShort()) {
      setTimeout(() => {
        this.self.shadowRoot
          .querySelector("iframe")
          ?.contentWindow?.postMessage(
            '{"event":"command","func":"' + "playVideo" + '","args":""}',
            "*",
          );
      }, 2000);
    }
  }
  isYouTubeShort() {
    return (
      this.self.getAttribute("short") === "" &&
      window.matchMedia("(max-width: 40em)").matches
    );
  }
  static addPrefetch(kind, url) {
    const linkElem = document.createElement("link");
    linkElem.rel = kind;
    linkElem.href = url;
    linkElem.crossOrigin = "true";
    document.head.append(linkElem);
  }
  static warmConnections(noCookie = false) {
    const connectionType = noCookie ? "privacy" : "standard";
    if (LiteYTEmbedDiv.preconnected[connectionType]) return;
    LiteYTEmbedDiv.addPrefetch("preconnect", "https://s.ytimg.com");
    LiteYTEmbedDiv.addPrefetch("preconnect", "https://i.ytimg.com");
    if (noCookie) {
      LiteYTEmbedDiv.addPrefetch(
        "preconnect",
        "https://www.youtube-nocookie.com",
      );
    } else {
      LiteYTEmbedDiv.addPrefetch("preconnect", "https://www.youtube.com");
      LiteYTEmbedDiv.addPrefetch("preconnect", "https://www.google.com");
      LiteYTEmbedDiv.addPrefetch(
        "preconnect",
        "https://googleads.g.doubleclick.net",
      );
      LiteYTEmbedDiv.addPrefetch(
        "preconnect",
        "https://static.doubleclick.net",
      );
    }
    LiteYTEmbedDiv.preconnected[connectionType] = true;
  }

  static init(root = document) {
    const videos = [];

    if (root.matches && root.matches(".lite-youtube, .lite-youtube-dev, lite-youtube")) {
      videos.push(root);
    }
    if (root.querySelectorAll) {
      videos.push(
        ...root.querySelectorAll(".lite-youtube, .lite-youtube-dev, lite-youtube"),
      );
    }

    videos.forEach((video) => new LiteYTEmbedDiv(video));
  }
}

LiteYTEmbedDiv.preconnected = { privacy: false, standard: false };
window.LiteYTEmbedDiv = LiteYTEmbedDiv;
LiteYTEmbedDiv.init(document);
